import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoggerService } from '../shared/logger.service';
import { StorageService } from '../auth/storage.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CommonModule, ViewportScroller } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';

import { all } from '@awesome.me/kit-787edf9aa0/icons';

export const homeLocationName = 'homeLocation';

@Component({
  selector: 'app-home-logged-out',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    RouterLinkActive,
    FontAwesomeModule
  ],
  templateUrl: './home-logged-out.component.html',
  styleUrl: './home-logged-out.component.scss'
})
export class HomeLoggedOutComponent implements OnInit, OnDestroy {

  private _homeLocation = new BehaviorSubject<string>('');
  get homeLocation() {
    return this._homeLocation.getValue();
  }
  set homeLocation(val: string) {
    this._homeLocation.next(val);
  }

  private _selectedFrag: BehaviorSubject<string> = new BehaviorSubject<string>('');
  get selectedFrag() {
    return this._selectedFrag.getValue();
  }
  set selectedFrag(val: string) {
    this._selectedFrag.next(val);
  }

  private _subs: Subscription[] = [];

  constructor(private logger: LoggerService,
    private storage: StorageService,
    public faIcons: FaIconLibrary,
    private scroller: ViewportScroller,
    private activeRoute: ActivatedRoute
  ) {
    faIcons.addIcons(...all);
  }

  ngOnInit(): void {
    this.logger.debug(`ngOnInit...`);
    this.setLocation('');
    // if (this.storage.exists(homeLocationName)) {
    //   this.homeLocation = <string>this.storage.get(homeLocationName);
    // }
    this._subs.push(this.activeRoute.fragment.subscribe(frag => {
      this.logger.debug('ngOnInit:frag: ', frag);
      this.setLocation(frag!);
    }));

  }

  ngOnDestroy(): void {
    this.logger.debug(`ngOnDestroy...`);
    this._subs.forEach(s => s.unsubscribe());
  }

  backToTop() {
    this.logger.debug(`backToTop...`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private setLocation(val: string) {
    if (this.storage.exists(homeLocationName)) {
      this.homeLocation = <string>this.storage.get(homeLocationName);
    }
    if (val !== '') {
      this.selectedFrag = val;
      setTimeout(() => {
        this.scroller.scrollToAnchor(this.selectedFrag);
      })
    }
  }

}
